import { useTranslation } from 'react-i18next'
import HomeFilter from '../components/HomeFilter'
import AnnouncesMassage from '../components/announces-massage'
import ContactForm from '../components/ContactForm'

export default function MassagePage() {
  const { t } = useTranslation()
  return (
    <>
      <div
        id='premium-slider'
        className='text-center w-full align-middle bg-redpink text-white  py-3'
      >
        <p className='uppercase text-2xl'>{t('professional-massage-corner')}</p>
        <p className=''>{t('professional-massage-corner-desc')}</p>
      </div>
      <div
        id='home-filter'
        className='w-full mx-auto justify-center text-anthracite'
      >
        <HomeFilter />
      </div>
      <div
        id='announces-home'
        className='w-full  mx-auto justify-center text-anthracite'
      >
        <AnnouncesMassage />
      </div>

      <ContactForm />
    </>
  )
}
